module.exports = __webpack_public_path__ + "img/safe_05.366c62cc.png";